import styled from "styled-components";

export const H1 = styled.h1`
  color: ${({ theme, $colour }) =>
    $colour ? theme.colours[$colour] : "black"};
  font-size: 54px;
  font-weight: 400;
  line-height: 54px;
  margin-bottom: 20px;

  @media (${({ theme }) => theme.mq.l}) {
    font-size: 78px;
    line-height: 78px;
  }

  em {
    text-transform: none;
    font-style: normal;
    background-image: linear-gradient(
      270deg,
      #3152ce 0%,
      #53a1f7 45%,
      #79f3c7 100%
    );
    background-size: cover;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-box-decoration-break: clone;
  }
`;

export const H2 = styled.h2`
  color: ${({ theme, $colour }) =>
    $colour ? theme.colours[$colour] : "black"};
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: 400;
  font-size: 28px;
  line-height: 30px;
  margin-bottom: 20px;

  @media (${({ theme }) => theme.mq.m}) {
    font-size: 48px;
    line-height: 48px;
  }
`;

export const H3 = styled.h3`
  color: ${({ theme, $colour }) =>
    $colour ? theme.colours[$colour] : "black"};
  font-size: 28px;
  line-height: 30px;
  margin-bottom: 20px;

  @media (${({ theme }) => theme.mq.m}) {
    font-size: 44px;
    line-height: 48px;
  }
`;

export const H4 = styled.h4`
  color: ${({ theme, $colour }) =>
    $colour ? theme.colours[$colour] : "black"};
  font-size: 24px;
  line-height: 26px;
  margin-bottom: 20px;
`;

export const H5 = styled.h5`
  color: ${({ theme, $colour }) =>
    $colour ? theme.colours[$colour] : "black"};
`;

export const H6 = styled.h6`
  color: ${({ theme, $colour }) =>
    $colour ? theme.colours[$colour] : "black"};
`;
